const navs = [
    {
        name: "labels.releases",
        url: "/releases/",
        icon: "question",
        role: "tech",
    },
    {
        name: "labels.documentation",
        url: "/documentation/",
        icon: "book",
        role: "tech",
    },
];

export default navs;
